<template>
  <v-container class="input-text-size">
    <MiscMtgTransactionCriteria
      :baseCrudKey="baseCrudKey"
      @loadCRUDList="getApportionmentMiscMtgRecord"
    />
  <CRUDList
      ref="crudList"
      :canAdd="true"
      :headers='headers'
      :displayTopPagination="false"
      :canEdit="false"
      :canSave="true"
      :showDate="false"
      :showTotal="true"
      :enableFixedHeaders="true"
      :baseCrudKey="baseCrudKey"
      @loadCRUDList="getApportionmentMiscMtgRecord"
      @upsertItem="upsertTransaction"
      canSaveCustomLabel="Continue"
      tableWrapperDynamicClassname='elevation-3 ma-3 pa-3 taxroll-table-wrapper'
      tableDynamicClassname='taxroll-custom-table'
      tableDynamicHeight='350'
      dialogDynamicWidth="700"
  >
  <template v-slot:[`editedItem`]="{}">
    <MiscMtgEditedItemVue
    ref="miscMtgEditedItem"
    :baseCrudKey="baseCrudKey"
    />
  </template>
  </CRUDList>
              <div class="flex-btns input-text-size">
                  <div class="apportionment-btns">
                    <v-row class="flex-row">
                      <v-col cols="4" class="input-text-size">
                        <p class="mt-6">Business Date : </p>
                      </v-col>
                      <v-col cols='3'>
                        <ClarionDateControl
                          class="input-text-size"
                          v-model="criteriaState.fromBusinessDateValue"
                          :isToggle="false"
                          label="From Date"
                          dynamicId="miscMtg-from-date"
                          @blurred="changeTheCriteriaBusinessFromDate"
                        />
                      </v-col>
                      <v-col cols='3'>
                        <ClarionDateControl
                          class="input-text-size"
                          v-model="criteriaState.toBusinessDateValue"
                          label="To Date"
                          :isToggle="false"
                          dynamicId="miscMtg-to-date"
                          @blurred="changeTheCriteriaBusinessToDate"
                        />
                      </v-col>
                    </v-row>
                    <v-row class="mt-0">
                      <v-btn color="primary" small rounded
                      @click="openDailogforTrailRecords">
                        Build Records
                      </v-btn>
                    </v-row>
                  </div>
                  <div class="apportionment-btn">
                    <v-row class="mt-6">
                      <v-row>
                          <v-btn
                            color="primary"
                            small
                            rounded
                            class="mb-2"
                            @click="printAlcoholicBeverageTaxReport"
                          >
                            Print Allocation of Alcoholic Beverage Tax Report
                          </v-btn>
                      </v-row>
                      <v-row>
                        <v-btn
                          color="primary"
                          small
                          rounded
                          class="mb-2"
                          @click="printMotorVehicleTaxreport"
                        >
                          Print Allocation of Motor Vehicle Tax Report
                        </v-btn>
                      </v-row>
                    </v-row>
                    <!-- Invalid Date Range Dialog -->
                    <v-dialog max-width="500" v-model="dialogForInvalidDateRange">
                      <v-card>
                        <v-card-title class="input-text-size error--text">
                          Invalid Date Range
                        </v-card-title>
                        <v-card-text class="input-text-size">
                          <v-alert type="warning" outlined class="mb-3">
                            You can only build MISC & MTG records for a single month.
                            Please change your date range and try again.
                          </v-alert>
                          <p class="mb-3">Would you like to proceed anyway?</p>
                          <div class="d-flex justify-space-around">
                            <v-btn
                              color="blue darken-1"
                              text
                              disabled
                              class="input-text-size"
                            >
                              NORMAL
                            </v-btn>
                            <v-btn
                              color="blue darken-1"
                              text
                              class="input-text-size"
                              @click="proceedWithInvalidRange('trial')"
                            >
                              TRIAL
                            </v-btn>
                            <v-btn
                              color="blue darken-1"
                              text
                              class="input-text-size"
                              @click="closeInvalidDateRangeDialog"
                            >
                              Cancel
                            </v-btn>
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-dialog>
                    <!-- Trail Records Dialog -->
                    <v-dialog max-width="400" v-model="dialogforTrailRecords">
                      <v-card>
                        <v-card-title class="input-text-size">
                          Type of Apportionmnet Records to create
                        </v-card-title>
                        <v-card-text>
                          <v-btn
                            color="blue darken-1"
                            text
                            @click="setTrialOption(false)"
                          >
                            NORMAL
                          </v-btn>
                          <v-btn
                            color="blue darken-1"
                            text
                            @click="setTrialOption(true)"
                          >
                            TRIAL
                          </v-btn>
                          <v-btn
                            color="blue darken-1"
                            text
                            @click="closeDialog"
                          >
                            Cancel
                          </v-btn>
                        </v-card-text>
                      </v-card>
                    </v-dialog>
                  </div>
                  </div>
    <!-- GL Fund Error Dialog -->
    <v-dialog v-model="showGLFundErrorDialog" max-width="600px" persistent>
      <v-card>
        <v-card-text class="mt-2">
          <!-- {{ currentGLFundError }} -->
          <v-alert type="error" outlined class="mb-2 mt-2">
            <strong>{{ currentValidationHeadline || ''}}</strong>
          </v-alert>
          <div v-if="currentGLFundError">
            <h4 class="mb-3">
              Record Details ({{ currentErrorIndex + 1 }} of {{ glFundErrorArray.length }}):
            </h4>
            <!-- Debug info - always show for now to help troubleshoot -->
            <!-- <div class="mb-3 pa-2" style="background-color: #f5f5f5; border: 1px solid #ddd;">
              <strong>Debug Info:</strong>
              <pre style="font-size: 12px;">{{ JSON.stringify(debugErrorInfo, null, 2) }}</pre>
            </div> -->
            <v-simple-table dense>
              <tbody>
                <tr>
                  <td><strong>Amount:</strong></td>
                  <td class="error--text">
                    {{ formatCurrencyForDisplay(currentGLFundError.amount || 'MISSING') }}
                  </td>
                </tr>
                <tr>
                  <td><strong>Section:</strong></td>
                  <td class="error--text">{{ currentGLFundError.section || 'MISSING' }}</td>
                </tr>
                <tr>
                  <td><strong>Source No:</strong></td>
                  <td class="error--text">{{ currentGLFundError.sourceNo || 'MISSING' }}</td>
                </tr>
                <tr>
                  <td><strong>Source Description:</strong></td>
                  <td class="error--text">{{ currentGLFundError.sourceDesc || 'MISSING' }}</td>
                </tr>
               <tr>
                  <td><strong>Tax Unit:</strong></td>
                  <td class="error--text">{{ currentGLFundError.unit || 'MISSING'}}</td>
                </tr>
                 <tr>
                  <td><strong>Unit Fund:</strong></td>
                  <td class="error--text">{{ currentGLFundError.fund || 'MISSING' }}</td>
                </tr>
                <tr></tr>
                <tr>
                  <td><strong>GL Fund:</strong></td>
                  <td class="error--text">{{ currentGLFundError.fundNo || 'MISSING' }}</td>
                </tr>
                <tr>
                  <td><strong>Fund Description:</strong></td>
                  <td class="error--text">{{ currentGLFundError.fundDesc || 'MISSING' }}</td>
                </tr>
                <tr>
                  <td><strong>Money From :</strong></td>
                  <td class="error--text">{{  currentGLFundError.moneyFrom || 'MISSING'}}</td>
                </tr>
                <tr>
                  <td><strong>Alt Key :</strong></td>
                  <td class="error--text">{{  currentGLFundError.tag.altKey || 'MISSING'}}</td>
                </tr>
                 <tr>
                  <td><strong>Receipt No :</strong></td>
                  <td class="error--text">{{  currentGLFundError.miscReceiptNo || 'MISSING'}}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="hasMoreErrors"
            color="primary"
            text
            @click="showNextError"
          >
            <v-icon left>mdi-arrow-right</v-icon>
            Continue ({{ currentErrorIndex + 1 }}/{{ glFundErrorArray.length }})
          </v-btn>
          <v-btn
            v-else
            color="primary"
            text
            @click="handleGLFundError('continue')"
          >
            <v-icon left>mdi-check</v-icon>
            Continue
          </v-btn>
          <v-btn
            color="warning"
            text
            @click="handleGLFundError('skip')"
          >
            Skip
          </v-btn>
          <v-btn color="error" text @click="handleGLFundError('abort')">
            <v-icon left>mdi-close</v-icon>
            Abort
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
          <CRUDDialog ref="crudDialog" :baseCrudKey="baseCrudKeyForPostingPeriodCheck"
  dialogDynamicWidth="50vw"
  :canSave="false"
  :canCancel="false">
    <template v-slot:[`editedItem`]="{ }">
     <p>
Your apportionment date range of {{criteriaState.fromDate}} - {{criteriaState.toDate}}
falls within the current posting period of
{{taxSettingItem.curPostPerFromDate}} - {{taxSettingItem.curPostPerToDate}}.
You must roll your posting period forward to the next month before you do your apportionment.
Please navigate to Payments - Utils - Posting Period and complete
the necessary steps to close out your posting period.
Then you may retry the Build Records step for the apportionment here on this page.
     </p>
    </template>
     <template v-slot:[`additionalActionsAfterSave`]="{}">
        <v-btn class="input-text-size" text color="blue darken-1"
        @click="onClose">Ok</v-btn>
      </template>
      </CRUDDialog>
</v-container>
</template>

<script>
import {
  mapGetters, mapMutations, mapActions, mapState,
} from 'vuex';
import CRUDList from '../../common/base/crud-2.0/CRUDList.vue';
import ClarionDateControl from '../../common/ClarionDateControl.vue';
import { miscMtgTransactionListHeaders } from '../apportionmentutils/apportionmentTableHeader';
import MiscMtgTransactionCriteria from './MiscMtgTransactionCriteria.vue';
import { amountToNumber, defaultGridLoading, manageGridLoading } from '../../../util/shared/vue-global';
import { toIsoDate, toShortDate, getDefaultMonthRange } from '../../../util/shared/tmc-global';
import MiscMtgEditedItemVue from './miscMtgEditedItem.vue';
import { generateQueryString } from '../../common/base/report/report-util';
import { clients } from '../../../util/clients';
import { isValidDateRange } from '../common';
import { printerHandler } from '../../../util/pdf-to-printer.util';
import CRUDDialog from '../../common/base/crud-2.0/CRUDDialog.vue';

const { backendRest } = clients.direct;

export default {
  data() {
    return {
      headers: miscMtgTransactionListHeaders,
      baseCrudKey: 'miscMtgBaseCrudKey',
      gridLoading: defaultGridLoading(),
      dialogforTrailRecords: false,
      dialogForInvalidDateRange: false,
      isTrail: false,
      showGLFundErrorDialog: false,
      glFundErrorData: null,
      glFundErrorArray: [],
      currentErrorIndex: 0,
      validationHeadline: null,
      pendingUpsertCall: null,
      baseCrudKeyForPostingPeriodCheck: 'baseCrudKeyForPostingPeriodCheck',
    };
  },
  created() {
    // Use getDefaultMonthRange to set initial business date fields if not already set
    const { fromDateValue, toDateValue } = getDefaultMonthRange();
    if (!this.criteriaState.fromBusinessDateValue) {
      this.criteriaState.fromBusinessDateValue = fromDateValue;
    }
    if (!this.criteriaState.toBusinessDateValue) {
      this.criteriaState.toBusinessDateValue = toDateValue;
    }
  },
  components: {
    CRUDList,
    MiscMtgTransactionCriteria,
    ClarionDateControl,
    MiscMtgEditedItemVue,
    CRUDDialog,
  },
  computed: {
    ...mapGetters('base/crud', ['criteria', 'isVisible']),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    criteriaStateForTaxesApport: {
      get() {
        return this.criteria('taxesApprotionment');
      },
      set(value) {
        this.setCriteria(['taxesApprotionment', value]);
      },
    },
    criteriaStateForApportionment: {
      get() {
        return this.criteria('approtionmentTab');
      },
      set(value) {
        this.setCriteria(['approtionmentTab', value]);
      },
    },
    ...mapState({
      apportionmentMiscMtgStoreItems:
      (state) => state.apportionment.apprMiscMtg.apportionmentMiscMtgItems,
      isLockedRecordAvailable: (state) => state.apportionment.apprMiscMtg.isLockedRecordAvailable,
      taxSettingItem: (state) => state.SystemConfig.taxSettingItem,

    }),
    selectedItems: {
      get() {
        return this.apportionmentMiscMtgStoreItems;
      },
      set(value) {
        this.setApportionmentMiscMtgItems(value);
      },
    },
    checkLockedRecords: {
      get() {
        return this.isLockedRecordAvailable;
      },
    },
    currentGLFundError() {
      const hasErrors = this.glFundErrorArray.length > 0;
      const validIndex = this.currentErrorIndex < this.glFundErrorArray.length;
      if (hasErrors && validIndex) {
        const currentError = this.glFundErrorArray[this.currentErrorIndex];
        // Handle nested structure where actual record data is in recordData property
        if (currentError && currentError.recordData) {
          return currentError.recordData;
        }
        return currentError;
      }
      return this.glFundErrorData; // Fallback for backward compatibility
    },
    hasMoreErrors() {
      return this.currentErrorIndex < this.glFundErrorArray.length - 1;
    },
    debugErrorInfo() {
      return {
        glFundErrorArrayLength: this.glFundErrorArray.length,
        currentErrorIndex: this.currentErrorIndex,
        currentError: this.currentGLFundError,
        hasErrors: this.glFundErrorArray.length > 0,
      };
    },
    currentValidationHeadline() {
      const hasErrors = this.glFundErrorArray.length > 0;
      const validIndex = this.currentErrorIndex < this.glFundErrorArray.length;
      if (hasErrors && validIndex) {
        const currentError = this.glFundErrorArray[this.currentErrorIndex];
        return currentError.message || this.validationHeadline;
      }
      return this.validationHeadline;
    },
  },
  methods: {
    ...mapActions(['reAuth']),
    ...mapMutations('base/crud', [
      'setCriteria', 'setIsVisible',
    ]),
    manageGridLoading,
    ...mapMutations('apprMiscMtg', [
      'setApportionmentMiscMtgItems',
    ]),
    ...mapActions('apportionment/apprMiscMtg', [
      'loadApportionmentMiscMtgRecords',
      'loadApportionmentMiscMtgBuildRecords',
      'upsertMiscMtgRecord',
      'checkForLockedRecords',
    ]),
    ...mapActions('apportionment/apportionmentTab', [
      'deleteRecordFromApportionment',
    ]),
    getApportionmentMiscMtgRecord() {
      const { baseCrudKey } = this;
      const criteria = {
        ...this.criteriaState,
      };
      criteria.fromDate = this.criteriaState.fromDate
        ? toIsoDate(this.criteriaState.fromDate) : null;
      criteria.toDate = this.criteriaState.toDate
        ? toIsoDate(this.criteriaState.toDate) : null;
      delete criteria.fromBusinessDateValue;
      delete criteria.toBusinessDateValue;
      delete criteria.fromDateValue;
      delete criteria.toDateValue;
      manageGridLoading(this, true, 'Searching...');
      this.loadApportionmentMiscMtgRecords({ criteria, baseCrudKey }).finally(() => {
        manageGridLoading(this, false);
      });
    },
    openDailogforTrailRecords() {
      const fromDate = toIsoDate(this.criteriaState.fromBusinessDateValue);
      const toDate = toIsoDate(this.criteriaState.toBusinessDateValue);
      if (isValidDateRange(fromDate, toDate)) {
        this.dialogforTrailRecords = true;
      } else {
        this.dialogForInvalidDateRange = true;
      }
    },
    closeDialog() {
      this.dialogforTrailRecords = false;
    },
    closeInvalidDateRangeDialog() {
      this.dialogForInvalidDateRange = false;
    },
    proceedWithInvalidRange(type) {
      this.dialogForInvalidDateRange = false;
      if (type === 'trial') {
        // Proceed with trial record creation despite invalid date range
        this.setTrialOption(true);
      }
    },
    async setTrialOption(val) {
      this.isTrail = val;
      const criteria = {
        fromDate: toIsoDate(this.criteriaState.fromBusinessDateValue),
        toDate: toIsoDate(this.criteriaState.toBusinessDateValue),
        isTrialRecord: val,
      };
      if (val) {
        this.addApprotDialog(criteria);
      } else {
        await this.checkForLockedRecords({ criteria });
        if (this.isLockedRecordAvailable) {
          alert(`You must unlock all MISC & MTG records for the date range ${this.criteriaState.fromDate} - ${this.criteriaState.toDate} before building records again.`);
        } else {
          const postPerToDate = new Date(this.taxSettingItem.curPostPerToDate);
          const criteriaToDate = new Date(this.criteriaState.toDate);
          if (criteriaToDate >= postPerToDate) {
            this.setIsVisible([this.baseCrudKeyForPostingPeriodCheck, true]);
            this.dialogforTrailRecords = false;
            // this.dialogforTrailRecords = false;
            return;
          }
          this.addApprotDialog(criteria);
        }
      }
      this.closeDialog();
    },
    async addApprotDialog(criteria) {
      const { baseCrudKey } = this;
      const results = await this.loadApportionmentMiscMtgBuildRecords({ criteria, baseCrudKey });
      if (results.status === 'overlapping_dates found') {
        alert('Overlapping date ranges found. Please correct the date ranges and try again.');
      } else {
        this.setIsVisible([this.baseCrudKey, true]);
        setTimeout(() => {
          this.$refs.miscMtgEditedItem.roundAmount();
        }, 100);
      }
    },
    emitSelectedItem(id) {
      this.selectedItems = id;
    },
    async upsertTransaction(item) {
      const { baseCrudKey } = this;
      const updatedItem = { ...item, isTrialRecord: this.isTrail };
      updatedItem.totalMtgTax = amountToNumber(updatedItem.totalMtgTax);
      updatedItem.totalCertFees = amountToNumber(updatedItem.totalCertFees);
      updatedItem.totalMisc = amountToNumber(updatedItem.totalMisc);
      updatedItem.jointMill = amountToNumber(updatedItem.jointMill);
      updatedItem.mvTaxStamps = amountToNumber(updatedItem.mvTaxStamps);
      updatedItem.otherADA = amountToNumber(updatedItem.otherADA);
      updatedItem.alcoholicBevTax = amountToNumber(updatedItem.alcoholicBevTax);
      updatedItem.otherADA = amountToNumber(updatedItem.otherADA);
      updatedItem.motorVechicle = amountToNumber(updatedItem.motorVechicle);
      updatedItem.otherCensus = amountToNumber(updatedItem.otherCensus);
      updatedItem.apportionLikeTaxes = amountToNumber(updatedItem.apportionLikeTaxes);
      updatedItem.totalofSpecialApportionment = amountToNumber(
        updatedItem.totalofSpecialApportionment,
      );
      // const criteria = { checkValidation: true };

      try {
        const itemCopy = { ...updatedItem, checkValidation: true };
        delete itemCopy.status;
        const response = await this.upsertMiscMtgRecord({
          item: itemCopy,
          baseCrudKey,
        });

        this.getApportionmentMiscMtgRecord();
        return response;
      } catch (error) {
        if (error.message === 'VALIDATION_ERROR') {
          // Store the pending call for later execution if user chooses to continue
          this.pendingUpsertCall = {
            item: { ...updatedItem },
            baseCrudKey,
          };
          this.setupGLFundErrorData(error);
          this.validationHeadline = error.headline;
          this.showGLFundErrorDialog = true;
          return null; // Return null when validation error occurs
        }
        // Re-throw other errors
        throw error;
      }
    },
    // getCriteria() {
    //   const res = this.criteria('taxesApprotionment');
    //   console.info('res ---- ', res);
    //   if (res) {
    //     this.fromBusinessDateValue = res.fromDateValue;
    //     this.toBusinessDateValue = res.toDateValue;
    //   }
    // },
    async printMotorVehicleTaxreport() {
      const { jwt } = await this.reAuth();
      const getcriteria = {
        ...this.criteriaState,
      };
      const params = [];
      if (this.criteriaState.fromDate && this.criteriaState.toDate) {
        params.push(`fromDate=${toShortDate(this.criteriaState.fromDate)}`);
        params.push(`toDate=${toShortDate(this.criteriaState.toDate)}`);
      } else {
        params.push(`fromDate=${toShortDate(new Date())}`);
        params.push(`toDate=${toShortDate(new Date())}`);
      }
      params.push(`isPrintTrial=${this.criteriaState.typeOfRecord}`);
      if (this.devSetting && this.devSetting.isTestEnvironment) {
        params.push('isTestCafe=1');
      }
      params.push(`token=${jwt}`);
      const encodedCriteria = encodeURIComponent(JSON.stringify(getcriteria));
      params.push(`filters=${encodedCriteria}`);

      const queryString = generateQueryString(params);
      const url = `${backendRest.defaults.baseURL}/apportionmnet/MVTReport${queryString}`;
      // window.open(url, '_blank');
      printerHandler(this, { url });
    },
    async printAlcoholicBeverageTaxReport() {
      const { jwt } = await this.reAuth();
      const getcriteria = {
        ...this.criteriaState,
      };
      const params = [];
      if (this.criteriaState.fromDate && this.criteriaState.toDate) {
        params.push(`fromDate=${toShortDate(this.criteriaState.fromDate)}`);
        params.push(`toDate=${toShortDate(this.criteriaState.toDate)}`);
      }
      params.push(`isPrintTrial=${this.criteriaState.typeOfRecord}`);
      if (this.devSetting && this.devSetting.isTestEnvironment) {
        params.push('isTestCafe=1');
      }
      params.push(`token=${jwt}`);
      const encodedCriteria = encodeURIComponent(JSON.stringify(getcriteria));
      params.push(`filters=${encodedCriteria}`);

      const queryString = generateQueryString(params);
      const url = `${backendRest.defaults.baseURL}/apportionmnet/ABTReport${queryString}`;
      // window.open(url, '_blank');
      printerHandler(this, { url });
    },
    setupGLFundErrorData(errorData) {
      // Handle the nested error structure from the debug data
      if (errorData && errorData.recordData && errorData.recordData.invalidRecords
          && Array.isArray(errorData.recordData.invalidRecords)) {
        // Extract invalidRecords from the nested structure
        this.glFundErrorArray = errorData.recordData.invalidRecords;
        this.currentErrorIndex = 0;
        this.glFundErrorData = this.glFundErrorArray.length > 0 ? this.glFundErrorArray[0] : null;
      } else if (errorData && errorData.invalidRecords && Array.isArray(errorData.invalidRecords)) {
        // Handle the case where invalidRecords is directly on errorData
        this.glFundErrorArray = errorData.invalidRecords;
        this.currentErrorIndex = 0;
        this.glFundErrorData = this.glFundErrorArray.length > 0 ? this.glFundErrorArray[0] : null;
      } else if (Array.isArray(errorData)) {
        // Handle direct array case (backward compatibility)
        this.glFundErrorArray = errorData;
        this.currentErrorIndex = 0;
        this.glFundErrorData = errorData.length > 0 ? errorData[0] : null;
      } else {
        // Handle single object case (backward compatibility)
        this.glFundErrorArray = errorData ? [errorData] : [];
        this.currentErrorIndex = 0;
        this.glFundErrorData = errorData;
      }
    },
    showNextError() {
      if (this.hasMoreErrors) {
        this.currentErrorIndex += 1;
      }
    },
    onClose() {
      this.setIsVisible([this.baseCrudKeyForPostingPeriodCheck, false]);
    },
    handleGLFundError(action) {
      if (action === 'continue' || action === 'skip') {
        // User chose to continue despite the error
        this.showGLFundErrorDialog = false;
        this.resetGLFundErrorData();

        // If there's a pending call, execute it
        if (this.pendingUpsertCall) {
          this.executePendingUpsertCall();
        }
      } else {
        // User chose to abort
        this.showGLFundErrorDialog = false;
        this.resetGLFundErrorData();
        this.pendingUpsertCall = null;
      }
    },
    resetGLFundErrorData() {
      this.glFundErrorData = null;
      this.glFundErrorArray = [];
      this.currentErrorIndex = 0;
      this.validationHeadline = null;
    },
    async executePendingUpsertCall() {
      if (!this.pendingUpsertCall) return;

      try {
        const { item, baseCrudKey } = this.pendingUpsertCall;
        const itemCopy = { ...item, checkValidation: false };
        delete itemCopy.status;
        // Execute without checkValidation when continuing after error
        await this.upsertMiscMtgRecord({
          item: itemCopy,
          baseCrudKey,
        });
        this.getApportionmentMiscMtgRecord();
      } catch (error) {
        // Handle any other errors that might occur
        console.error('Error in executePendingUpsertCall:', error);
      } finally {
        this.pendingUpsertCall = null;
      }
    },
    formatCurrencyForDisplay(amount) {
      if (amount === null || amount === undefined) return 'N/A';
      try {
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
        }).format(amount);
      } catch (error) {
        return amount.toString();
      }
    },
    changeTheCriteriaBusinessFromDate() {
      this.criteriaStateForTaxesApport.fromDateValue = this.criteriaState.fromBusinessDateValue;
      this.criteriaStateForTaxesApport.fromDate = this.criteriaState.fromBusinessDateValue;
      this.criteriaStateForApportionment.fromDate = this.criteriaState.fromBusinessDateValue;
      this.getApportionmentMiscMtgRecord();
    },
    changeTheCriteriaBusinessToDate() {
      this.criteriaStateForTaxesApport.toDateValue = this.criteriaState.toBusinessDateValue;
      this.criteriaStateForTaxesApport.toDate = this.criteriaState.toBusinessDateValue;
      this.criteriaStateForApportionment.toDate = this.criteriaState.toBusinessDateValue;
      this.getApportionmentMiscMtgRecord();
    },
  },
};

</script>

<style scoped>

.flex-btns {
  display: flex;
  flex-direction: row;
}
.apportionment-btns {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    gap: 2px;
}
</style>
